import React,{useEffect} from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
//import NavigationMenu from '../NavigationMenu';
//import { useNavigate } from 'react-router-dom';

function FooterContact(props) {
  //const navigate=useNavigate();

    useEffect(() => {

        }, []);
    return(
        <Box width='100%'>  


                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'30px'}}
                            >
                            <Box component="img"
                            justifyContent='center'
                                sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                                alt="Org Image"
                                src={process.env.PUBLIC_URL + "/images/arrange-11call-button.png"}
                                onClick={()=>{
                                    //navigate("/wheelguide");
                                    window.open('https://www.decama.co.uk/contact/', '_blank');
                                    }}
                            />

                        </Box>
                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'15px', paddingBottom:'10px'}}
                            >
                            <Box component="img"
                            justifyContent='center'
                                sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                                alt="Org Image"
                                src={process.env.PUBLIC_URL + "/images/visit-our-website-button.png"}
                                onClick={()=>{
                                    //navigate("/wheelguide");
                                    window.open('https://decama.co.uk/', '_blank');
                                    }}
                            />
                        </Box>
                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'10px'}}>
                            <Typography sx={{fontSize:'14px', fontWeight:'400', color:'grey', paddingBottom:'20px'}}>
                            ©February, 2025 DECAMA Limited, All Rights Reserved.
                            </Typography>
                        </Box>

        </Box>
    );
}
export default FooterContact;